<template>
  <div>
    <div class="page-header">
      <div>
        <div class="page-title">{{ isDetailMode ? '支付宝子商编详情' : '支付宝子商编申请' }}</div>
        <div class="page-subtitle">{{ isDetailMode ? '查看支付宝子商编详细信息' : '填写支付宝子商编申请信息' }}</div>
      </div>
      <el-button type="primary" plain @click="goBack">返回列表</el-button>
    </div>
    <el-card>
      <el-form label-width="160px">
        <!-- <el-form-item label="第三方标识" required>
          <el-input v-model="form.userIdIdentity" placeholder="请输入唯一标识，只能输入数字和字母" maxlength="50" show-word-limit />
        </el-form-item> -->
        <el-form-item label="MCC 码" required>
          <el-select v-model="form.mcc" placeholder="请选择MCC码" style="width: 100%">
            <el-option
              v-for="item in mccList"
              :key="item.value"
              :label="item.label + ' (' + item.value + ')'"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="渠道商编码" required>
          <el-input v-model="form.channelId" placeholder="请输入渠道商编码" maxlength="32" show-word-limit />
        </el-form-item>
        <el-form-item label="渠道商全称" required>
          <el-input v-model="form.channelFullName" placeholder="请输入渠道商全称" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="联系人姓名" required>
          <el-input v-model="form.linkmanName" placeholder="请输入联系人姓名" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="联系人业务标识" required>
          <el-select v-model="form.linkmanTag" placeholder="请选择联系人业务标识" style="width: 100%">
            <el-option label="异议处理接口人(02)" value="02" />
            <el-option label="商户关键联系人(06)" value="06" />
            <el-option label="数据反馈接口人(11)" value="11" />
            <el-option label="服务联动接口人(08)" value="08" />
          </el-select>
        </el-form-item>
        <el-form-item label="联系人类型" required>
          <el-select v-model="form.linkmanType" placeholder="请选择联系人类型" style="width: 100%">
            <el-option label="法人" value="LEGAL_PERSON" />
            <el-option label="实际控制人" value="CONTROLLER" />
            <el-option label="代理人" value="AGENT" />
            <el-option label="其他" value="OTHER" />
          </el-select>
        </el-form-item>
        <el-form-item label="联系人电话" required>
          <el-input v-model="form.linkmanPhone" placeholder="请输入联系人电话" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="联系人手机号">
          <el-input v-model="form.linkmanMobilePhone" placeholder="请输入联系人手机号" maxlength="11" show-word-limit />
        </el-form-item>
        <el-form-item label="联系人邮箱">
          <el-input v-model="form.linkmanEmail" placeholder="请输入联系人邮箱" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="联系人身份证号码">
          <el-input v-model="form.linkmanIdNumber" placeholder="请输入联系人身份证号码" maxlength="18" show-word-limit />
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="submitForm">{{ isDetailMode ? '修改信息' : '提交申请' }}</el-button>
          <el-button @click="goBack">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        // userIdIdentity: '',
        mcc: '',
        channelId: '',
        channelFullName: '',
        linkmanName: '',
        linkmanTag: '',
        linkmanType: '',
        linkmanPhone: '',
        linkmanMobilePhone: '',
        linkmanEmail: '',
        linkmanIdNumber: ''
      },
      // MCC码列表
      mccList: [
        { label: '公共事业（电、气、水）', value: '4900' },
        { label: '商用计算机及服务器', value: '5045' },
        { label: '计算机软件', value: '5734' },
        { label: '软件系统商', value: '7372' },
        { label: '信息检索服务', value: '7375' },
        { label: '计算机维护和修理服务', value: '7379' },
        { label: '其他娱乐服务', value: '7999' }
      ],
      // 是否为详情模式
      isDetailMode: false,
      // 子商编id
      subMerchantId: ''
    };
  },
  computed: {},
  // 页面挂载完成
  mounted() {
    // 检查是否有id参数
    this.checkForMerchantId();
  },
  methods: {
    // 检查URL参数中的商户id和子商编id
    checkForMerchantId() {
      const merchantId = this.$route.query.id;
      const subMerchantId = this.$route.query.subMerchantId;
      if (merchantId) {
        this.form.mid = merchantId;
        console.log('商户ID:', merchantId);
        if (subMerchantId) {
          // 进入详情模式
          this.isDetailMode = true;
          this.id = subMerchantId;
          console.log('子商编ID:', subMerchantId);
          this.loadSubMerchantDetails(subMerchantId);
        }
      } else {
        this.$message.error('缺少商户ID参数');
      }
    },
    // 加载子商编详情
    loadSubMerchantDetails(subMerchantId) {
      this.$http_get(`/admin/merchant/subMerchantDetail?id=${subMerchantId}`, 1).then(res => {
        if (res && res.code === 200 && res.data) {
          console.log('子商编详情:', res.data);
          // 填充表单数据
          this.form = {
            ...this.form,
            mcc: res.data.mcc || '',
            channelId: res.data.channelId || '',
            channelFullName: res.data.channelFullName || '',
            linkmanName: res.data.linkmanName || '',
            linkmanTag: res.data.linkmanTag || '',
            linkmanType: res.data.linkmanType || '',
            linkmanPhone: res.data.linkmanPhone || '',
            linkmanMobilePhone: res.data.linkmanMobilePhone || '',
            linkmanEmail: res.data.linkmanEmail || '',
            linkmanIdNumber: res.data.linkmanIdNumber || ''
          };
          this.$message.success('加载详情成功');
        } else {
          this.$message.error(res.msg || '加载子商编详情失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('加载子商编详情失败:', err);
      });
    },
    // 提交表单
    submitForm() {
      // 基本信息验证
      if (!this.form.mid) {
        this.$message.warning("缺少商户ID");
        return;
      }
      // if (!this.form.userIdIdentity) {
      //   this.$message.warning("请输入第三方标识");
      //   return;
      // }
      // if (!/^[a-zA-Z0-9]+$/.test(this.form.userIdIdentity)) {
      //   this.$message.warning("第三方标识只能包含数字和字母");
      //   return;
      // }
      if (!this.form.mcc) {
        this.$message.warning("请输入MCC码");
        return;
      }
      if (!this.form.channelId) {
        this.$message.warning("请输入渠道商编码");
        return;
      }
      if (!this.form.channelFullName) {
        this.$message.warning("请输入渠道商全称");
        return;
      }
      if (!this.form.linkmanName) {
        this.$message.warning("请输入联系人姓名");
        return;
      }
      if (!this.form.linkmanTag) {
        this.$message.warning("请选择联系人业务标识");
        return;
      }
      if (!this.form.linkmanType) {
        this.$message.warning("请选择联系人类型");
        return;
      }
      
      if (!this.form.linkmanPhone) {
        this.$message.warning("请选择联系人电话");
        return;
      }
      console.log('提交子商编申请:', this.form);
      this.$http_post("/admin/merchant/alipaysubMerchantApply", this.form, 1).then(res => {
        if (res && res.code === 200) {
          this.$message.success('提交成功');
        } else {
          this.$message.error(res.msg || '提交失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('提交子商编申请失败:', err);
      });
    },
    // 返回列表
    goBack() {
       this.$router.push("/onboarding");
    }
  }
};
</script>